import React, { useEffect, useMemo, useState } from "react";
import I from "../component/Icon";
import apiService from "../services/apiService";
import "../App.css"

export default function DashboardPage({ onNav, }) {

  const storedUser = JSON.parse(
    sessionStorage.getItem("user") || "{}"
  );

  const currentTeacherId = Number(
    sessionStorage.getItem("teacherId") ??
    storedUser?.teacherId ??
    storedUser?.TeacherId ??
    0
  );

  const isTeacher =
    currentTeacherId > 0;

  const getCurrentMonthStart = () => {
    const now = new Date();

    const year = now.getFullYear();

    const month = String(
      now.getMonth() + 1
    ).padStart(2, "0");

    return `${year}-${month}-01`;
  };

  const getCurrentMonthEnd = () => {
    const now = new Date();

    const lastDay = new Date(
      now.getFullYear(),
      now.getMonth() + 1,
      0
    );

    const year =
      lastDay.getFullYear();

    const month = String(
      lastDay.getMonth() + 1
    ).padStart(2, "0");

    const day = String(
      lastDay.getDate()
    ).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const [fromDate, setFromDate] =
    useState(getCurrentMonthStart);

  const [toDate, setToDate] =
    useState(getCurrentMonthEnd);

  const dateRange =
    `${fromDate}-${toDate}`;
  const [topSchoolsData, setTopSchoolsData] =
    useState([]);

  const [topSchoolsLoading, setTopSchoolsLoading] =
    useState(false);

  const [examPerformanceData, setExamPerformanceData] =
    useState([]);

  const [examPerformanceLoading, setExamPerformanceLoading] =
    useState(false);

  const [feesCollectionData, setFeesCollectionData] =
    useState([]);

  const [feesCollectionLoading, setFeesCollectionLoading] =
    useState(false);

  const [
    exportingReport,
    setExportingReport,
  ] = useState("");
  const [
    dashboardTotal,
    setDashboardTotal,
  ] = useState({
    userTotal: 0,
    totalAmount: 0,
    totalSchool: 0,
    totalStudent: 0,
    totalExam: 0,
    todaysStudent: 0,
    totalPendingPayment: 0,
  });
  const [
    bookPurchaseData,
    setBookPurchaseData,
  ] = useState([]);

  const [
    bookPurchaseLoading,
    setBookPurchaseLoading,
  ] = useState(false);



  const [
    dashboardTotalLoading,
    setDashboardTotalLoading,
  ] = useState(false);

  const [
    teacherStudentCount,
    setTeacherStudentCount,
  ] = useState(0);

  const [
    teacherStudentCountLoading,
    setTeacherStudentCountLoading,
  ] = useState(false);

  const [
    teacherTodayStudentCount,
    setTeacherTodayStudentCount,
  ] = useState(0);

  const [
    teacherTodayStudentLoading,
    setTeacherTodayStudentLoading,
  ] = useState(false);

  /* ========================================= */
  /* NOTIFICATION */
  /* ========================================= */

  const [notification, setNotification] = useState(null);
  const getTodayDate = () => {
    const today = new Date();

    const year =
      today.getFullYear();

    const month =
      String(
        today.getMonth() + 1
      ).padStart(2, "0");

    const day =
      String(
        today.getDate()
      ).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const showNotification = (type, message) => {
    setNotification({
      type,
      message,
    });
  };

  useEffect(() => {
    if (!notification) {
      return;
    }

    const timer = setTimeout(() => {
      setNotification(null);
    }, 3000);

    return () => clearTimeout(timer);
  }, [notification]);

  // Shared request shape verified by the working GetDashboardTotal API.
  const buildDashboardReportPayload = (reportType, isExportToExcel = false, teacherId = isTeacher ? currentTeacherId : 0) => ({
    reportType,
    mode: "string",
    pagination: {
      pageNumber: 1,
      rowsPerPage: 10,
      searchTerm: "",
      sortDirection: "DESC",
      sortField: "Id",
    },
    fromDate,
    toDate,
    allRecordsRequired: true,
    isExportToExcel,
    id: 0,
    month: "",
    studentId: "0",
    districtId: "0",
    teacherId: String(teacherId || 0),
  });

  const getTop10SchoolsPayload = (isExportToExcel = false) =>
    buildDashboardReportPayload("GetTop10SchoolsDashboard", isExportToExcel);
  const fetchTeacherBookPurchase = async () => {
    if (!isTeacher || currentTeacherId <= 0) {
      setBookPurchaseData([]);
      return;
    }

    try {
      setBookPurchaseLoading(true);

      const payload = buildDashboardReportPayload("GetTeacherWiseBookAssignDashboard", false, currentTeacherId);

      console.log(
        "Teacher Book Purchase Payload:",
        payload
      );

      const response = await apiService.post(
        "Report/allReportsQueryReport",
        payload
      );

      const data = response?.data;

      console.log(
        "Teacher Book Purchase Response:",
        data
      );

      if (
        data?.isSuccess === false ||
        data?.failureReason
      ) {
        throw new Error(
          data?.failureReason ||
          data?.message ||
          "Failed to load book purchase"
        );
      }

      const reportData =
        Array.isArray(data?.reportData)
          ? data.reportData
          : [];

      console.log(
        "Teacher Book Purchase Raw:",
        reportData
      );

      const colors = [
        "#2563EB",
        "#10B981",
        "#7C3AED",
        "#F97316",
        "#EF4444",
        "#0EA5E9",
        "#F59E0B",
        "#14B8A6",
        "#8B5CF6",
        "#EC4899",
      ];

      const formatted =
        reportData.map(
          (item, index) => {
            let label =
              item?.bookName ??
              item?.BookName ??
              item?.bookTitle ??
              item?.BookTitle ??
              item?.title ??
              item?.Title ??
              item?.name ??
              item?.Name ??
              "";
            let count =
              item?.quantity ??
              item?.Quantity ??
              item?.qty ??
              item?.Qty ??
              item?.bookQuantity ??
              item?.BookQuantity ??
              0;

            return {
              label,
              count: Number(count || 0),
              color:
                colors[
                index % colors.length
                ],
            };
          }
        );

      console.log(
        "Formatted Book Purchase:",
        formatted
      );

      setBookPurchaseData(
        formatted
      );
    } catch (error) {
      console.error(
        "Teacher Book Purchase API Error:",
        error
      );

      setBookPurchaseData([]);
    } finally {
      setBookPurchaseLoading(false);
    }
  };

  const fetchTop10Schools = async () => {
    try {
      setTopSchoolsLoading(true);

      const payload = getTop10SchoolsPayload(false);

      console.log(
        "Top 10 Schools Graph Payload:",
        payload
      );

      const response =
        await apiService.post(
          "Report/allReportsQueryReport",
          payload
        );

      const data = response.data;

      console.log(
        "Top 10 Schools Graph Response:",
        data
      );

      if (
        data?.isSuccess === false ||
        data?.failureReason
      ) {
        throw new Error(
          data?.failureReason ||
          "Failed to load Top 10 Schools"
        );
      }

      const reportData =
        Array.isArray(data?.reportData)
          ? data.reportData
          : [];

      console.log(
        "Top Schools Raw List:",
        reportData
      );

      const formatted =
        reportData.map((item) => ({
          name:
            item.schoolName || "",

          students:
            Number(
              item.studentCount || 0
            ),
        }));

      console.log(
        "Formatted Top Schools:",
        formatted
      );

      setTopSchoolsData(
        formatted
      );
    } catch (error) {
      console.error("Top 10 Schools API Error:", { status: error?.response?.status, response: error?.response?.data, request: error?.config?.data, error });

      setTopSchoolsData([]);
    } finally {
      setTopSchoolsLoading(false);
    }
  };

  const fetchExamPerformanceTrend = async () => {
    try {
      setExamPerformanceLoading(true);

      const payload = buildDashboardReportPayload("GetExamPerformanceTrendDashboard");

      console.log(
        "Exam Performance Trend Payload:",
        payload
      );

      const response =
        await apiService.post(
          "Report/allReportsQueryReport",
          payload
        );

      const data = response.data;

      console.log(
        "Exam Performance Trend Response:",
        data
      );

      if (
        data?.isSuccess === false ||
        data?.failureReason
      ) {
        throw new Error(
          data?.failureReason ||
          "Failed to load Exam Performance Trend"
        );
      }

      const reportData =
        Array.isArray(data?.reportData)
          ? data.reportData
          : [];

      const colors = [
        "#2563EB",
        "#10B981",
        "#7C3AED",
        "#F97316",
        "#EF4444",
        "#0EA5E9",
        "#F59E0B",
        "#14B8A6",
        "#8B5CF6",
        "#EC4899",
      ];

      const formatted =
        reportData.map(
          (item, index) => ({
            label:
              item.examName || "",
            count:
              Number(
                item.studentCount || 0
              ),
            color:
              colors[
              index % colors.length
              ],
          })
        );

      console.log(
        "Formatted Exam Performance Trend:",
        formatted
      );

      setExamPerformanceData(
        formatted
      );
    } catch (error) {
      console.error("Exam Performance Trend API Error:", { status: error?.response?.status, response: error?.response?.data, request: error?.config?.data, error });

      setExamPerformanceData([]);
    } finally {
      setExamPerformanceLoading(false);
    }
  };

  const fetchFeesCollection = async () => {
    try {
      setFeesCollectionLoading(true);

      const payload = buildDashboardReportPayload("GetFeesCollectionDashboard");

      console.log(
        "Fees Collection Payload:",
        payload
      );

      const response =
        await apiService.post(
          "Report/allReportsQueryReport",
          payload
        );

      const data = response.data;

      console.log(
        "Fees Collection Response:",
        data
      );

      if (
        data?.isSuccess === false ||
        data?.failureReason
      ) {
        throw new Error(
          data?.failureReason ||
          "Failed to load Fees Collection"
        );
      }

      const reportData =
        Array.isArray(data?.reportData)
          ? data.reportData
          : [];

      const formatted =
        reportData.map((item) => ({
          status: item.status || "",
          amount: Number(
            item.amount || 0
          ),
          percentage: Number(
            item.percentage || 0
          ),
        }));

      console.log(
        "Formatted Fees Collection:",
        formatted
      );

      setFeesCollectionData(
        formatted
      );
    } catch (error) {
      console.error("Fees Collection API Error:", { status: error?.response?.status, response: error?.response?.data, request: error?.config?.data, error });

      setFeesCollectionData([]);
    } finally {
      setFeesCollectionLoading(false);
    }
  };
  const fetchDashboardTotal =
    async () => {
      try {
        setDashboardTotalLoading(
          true
        );

        const payload = buildDashboardReportPayload("GetDashboardTotal");

        console.log(
          "Dashboard Total Payload:",
          payload
        );

        const response =
          await apiService.post(
            "Report/allReportsQueryReport",
            payload
          );

        const data =
          response.data;

        console.log(
          "Dashboard Total Response:",
          data
        );

        if (
          data?.isSuccess === false ||
          data?.failureReason
        ) {
          throw new Error(
            data?.failureReason ||
            "Failed to load Dashboard Total"
          );
        }

        const reportData =
          Array.isArray(
            data?.reportData
          )
            ? data.reportData
            : [];

        const item =
          reportData[0] || {};

        const formatted = {
          userTotal:
            Number(
              item.userTotal || 0
            ),

          totalAmount:
            Number(
              item.totalAmount || 0
            ),

          totalSchool:
            Number(
              item.totalSchool || 0
            ),

          totalStudent:
            Number(
              item.totalStudent || 0
            ),

          totalExam:
            Number(
              item.totalExam || 0
            ),

          todaysStudent:
            Number(
              item.todaysStudent || 0
            ),

          totalPendingPayment:
            Number(
              item.totalPendingPayment ||
              0
            ),
        };

        console.log(
          "Formatted Dashboard Total:",
          formatted
        );

        setDashboardTotal(
          formatted
        );
      } catch (error) {
        console.error(
          "Dashboard Total API Error:",
          error
        );

        setDashboardTotal({
          userTotal: 0,
          totalAmount: 0,
          totalSchool: 0,
          totalStudent: 0,
          totalExam: 0,
          todaysStudent: 0,
          totalPendingPayment: 0,
        });
      } finally {
        setDashboardTotalLoading(
          false
        );
      }
    };
  const fetchTeacherStudentCount = async () => {
    if (!isTeacher || currentTeacherId <= 0) {
      setTeacherStudentCount(0);
      return;
    }

    try {
      setTeacherStudentCountLoading(true);

      const payload = {
        page: 1,
        pageSize: 10,
        searchTerm: "",
        sortDirection: "desc",
        sortField: "Id",
        userId: 0,
        teacherId: currentTeacherId,
      };

      console.log(
        "Dashboard Teacher Student Payload:",
        payload
      );

      const response = await apiService.post(
        "Student/getPaginatedStudent",
        payload
      );

      let data = response?.data;

      if (typeof data === "string") {
        try {
          data = JSON.parse(data);
        } catch {
          // keep original value
        }
      }

      console.log(
        "Dashboard Teacher Student Response:",
        data
      );

      let output =
        data?.output ??
        data?.Output ??
        data?.data ??
        data?.Data ??
        data;

      if (typeof output === "string") {
        try {
          output = JSON.parse(output);
        } catch {
          // keep original value
        }
      }

      let rows = [];

      if (Array.isArray(output)) {
        rows = output;
      } else {
        const candidates = [
          output?.items,
          output?.Items,
          output?.data,
          output?.Data,
          output?.records,
          output?.Records,
          output?.result,
          output?.Result,
          output?.list,
          output?.List,
        ];

        for (let candidate of candidates) {
          if (typeof candidate === "string") {
            try {
              candidate = JSON.parse(candidate);
            } catch {
              // keep original value
            }
          }

          if (Array.isArray(candidate)) {
            rows = candidate;
            break;
          }
        }
      }

      const totalCandidates = [
        output?.totalRecords,
        output?.TotalRecords,
        output?.totalCount,
        output?.TotalCount,
        output?.recordCount,
        output?.RecordCount,
        output?.rowCount,
        output?.RowCount,

        data?.totalRecords,
        data?.TotalRecords,
        data?.totalCount,
        data?.TotalCount,
        data?.recordCount,
        data?.RecordCount,

        rows?.[0]?.totalRecords,
        rows?.[0]?.TotalRecords,
        rows?.[0]?.totalCount,
        rows?.[0]?.TotalCount,
        rows?.[0]?.recordCount,
        rows?.[0]?.RecordCount,
      ];

      let totalRecords = null;

      for (const value of totalCandidates) {
        if (
          value !== undefined &&
          value !== null &&
          value !== ""
        ) {
          const parsed = Number(value);

          if (Number.isFinite(parsed)) {
            totalRecords = parsed;
            break;
          }
        }
      }

      if (!Number.isFinite(totalRecords)) {
        totalRecords = rows.length;
      }

      console.log(
        "Dashboard Teacher Student Total:",
        totalRecords
      );

      setTeacherStudentCount(totalRecords);
    } catch (error) {
      console.error(
        "Teacher Student Count API Error:",
        error
      );

      setTeacherStudentCount(0);
    } finally {
      setTeacherStudentCountLoading(false);
    }
  };

  const fetchTeacherTodayStudentCount = async () => {
    if (!isTeacher || currentTeacherId <= 0) {
      setTeacherTodayStudentCount(0);
      return;
    }

    try {
      setTeacherTodayStudentLoading(true);

      const response = await apiService.post(
        "Student/getPaginatedStudent",
        {
          page: 1,
          pageSize: 10000,
          searchTerm: "",
          sortDirection: "desc",
          sortField: "Id",
          userId: 0,
          teacherId: currentTeacherId,
        }
      );

      let data = response?.data;

      if (typeof data === "string") {
        try {
          data = JSON.parse(data);
        } catch {
          // keep original
        }
      }

      let output =
        data?.output ??
        data?.Output ??
        data?.data ??
        data?.Data ??
        data;

      if (typeof output === "string") {
        try {
          output = JSON.parse(output);
        } catch {
          // keep original
        }
      }

      let rows = [];

      if (Array.isArray(output)) {
        rows = output;
      } else {
        const candidates = [
          output?.items,
          output?.Items,
          output?.data,
          output?.Data,
          output?.records,
          output?.Records,
          output?.result,
          output?.Result,
          output?.list,
          output?.List,
        ];

        for (let candidate of candidates) {
          if (typeof candidate === "string") {
            try {
              candidate = JSON.parse(candidate);
            } catch {
              // ignore
            }
          }

          if (Array.isArray(candidate)) {
            rows = candidate;
            break;
          }
        }
      }

      const now = new Date();

      const todayYear = now.getFullYear();
      const todayMonth = now.getMonth();
      const todayDate = now.getDate();

      const todayStudents = rows.filter((student) => {
        const createdValue =
          student?.createdDate ??
          student?.CreatedDate ??
          student?.createdOn ??
          student?.CreatedOn ??
          student?.createdAt ??
          student?.CreatedAt ??
          student?.dateCreated ??
          student?.DateCreated;

        if (!createdValue) {
          return false;
        }

        const createdDate = new Date(createdValue);

        if (Number.isNaN(createdDate.getTime())) {
          return false;
        }

        return (
          createdDate.getFullYear() === todayYear &&
          createdDate.getMonth() === todayMonth &&
          createdDate.getDate() === todayDate
        );
      });

      console.log(
        "Teacher Today Student Rows:",
        todayStudents
      );

      console.log(
        "Teacher Today Student Count:",
        todayStudents.length
      );

      setTeacherTodayStudentCount(
        todayStudents.length
      );
    } catch (error) {
      console.error(
        "Teacher Today Student Count Error:",
        error
      );

      setTeacherTodayStudentCount(0);
    } finally {
      setTeacherTodayStudentLoading(false);
    }
  };

  const exportDashboardReport = async (
    reportType,
    defaultFileName
  ) => {
    if (
      !fromDate ||
      !toDate ||
      exportingReport
    ) {
      return;
    }

    try {
      setExportingReport(
        reportType
      );

      const payload = buildDashboardReportPayload(reportType, true);

      console.log(
        `${reportType} Export Payload:`,
        payload
      );

      const response =
        await apiService.download(
          "Report/allReportsQueryReport",
          payload
        );

      console.log(
        `${reportType} Export Status:`,
        response?.status
      );

      const contentType =
        response?.headers?.[
        "content-type"
        ] ||
        response?.headers?.[
        "Content-Type"
        ] ||
        "";

      console.log(
        `${reportType} Export Content-Type:`,
        contentType
      );

      const responseData =
        response?.data;

      let arrayBuffer;

      if (
        responseData instanceof
        ArrayBuffer
      ) {
        arrayBuffer =
          responseData;
      } else if (
        ArrayBuffer.isView(
          responseData
        )
      ) {
        arrayBuffer =
          responseData.buffer.slice(
            responseData.byteOffset,
            responseData.byteOffset +
            responseData.byteLength
          );
      } else if (
        responseData instanceof Blob
      ) {
        arrayBuffer =
          await responseData.arrayBuffer();
      } else if (
        typeof responseData ===
        "string"
      ) {
        arrayBuffer =
          new TextEncoder().encode(
            responseData
          ).buffer;
      } else if (
        responseData !== undefined &&
        responseData !== null
      ) {
        const jsonText =
          JSON.stringify(
            responseData
          );

        arrayBuffer =
          new TextEncoder().encode(
            jsonText
          ).buffer;
      } else {
        throw new Error(
          "Empty response received while exporting Excel file."
        );
      }

      if (
        arrayBuffer.byteLength === 0
      ) {
        throw new Error(
          "Downloaded Excel file is empty."
        );
      }

      const bytes =
        new Uint8Array(
          arrayBuffer
        );

      const decodedPreview =
        new TextDecoder().decode(
          bytes.slice(
            0,
            Math.min(
              bytes.length,
              1000
            )
          )
        );

      if (
        String(contentType)
          .toLowerCase()
          .includes(
            "application/json"
          )
      ) {
        let errorData = null;

        try {
          errorData =
            JSON.parse(
              decodedPreview
            );
        } catch {
          // keep null
        }

        throw new Error(
          errorData?.failureReason ||
          errorData?.FailureReason ||
          errorData?.message ||
          errorData?.Message ||
          "Backend returned JSON instead of Excel file."
        );
      }

      const isValidXlsx =
        bytes.length >= 2 &&
        bytes[0] === 0x50 &&
        bytes[1] === 0x4b;

      console.log(
        `${reportType} Valid XLSX Signature:`,
        isValidXlsx
      );

      if (!isValidXlsx) {
        let backendMessage = "";

        try {
          const errorData =
            JSON.parse(
              decodedPreview
            );

          backendMessage =
            errorData?.failureReason ||
            errorData?.FailureReason ||
            errorData?.message ||
            errorData?.Message ||
            "";
        } catch {
          // response is not JSON
        }

        console.error(
          `${reportType} Invalid Excel response:`,
          decodedPreview
        );

        throw new Error(
          backendMessage ||
          "Server response is not a valid Excel file."
        );
      }

      const blob = new Blob(
        [arrayBuffer],
        {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }
      );

      const disposition =
        response?.headers?.[
        "content-disposition"
        ] ||
        response?.headers?.[
        "Content-Disposition"
        ] ||
        "";

      let fileName =
        `${defaultFileName}.xlsx`;

      const utfMatch =
        String(
          disposition
        ).match(
          /filename\*=UTF-8''([^;]+)/i
        );

      const normalMatch =
        String(
          disposition
        ).match(
          /filename="?([^";]+)"?/i
        );

      if (utfMatch?.[1]) {
        fileName =
          decodeURIComponent(
            utfMatch[1]
          );
      } else if (
        normalMatch?.[1]
      ) {
        fileName =
          normalMatch[1];
      }

      if (
        !fileName
          .toLowerCase()
          .endsWith(".xlsx")
      ) {
        fileName += ".xlsx";
      }

      const url =
        window.URL.createObjectURL(
          blob
        );

      const link =
        document.createElement(
          "a"
        );

      link.href = url;
      link.download = fileName;

      document.body.appendChild(
        link
      );

      link.click();

      document.body.removeChild(
        link
      );

      window.URL.revokeObjectURL(
        url
      );

      showNotification(
        "success",
        "Report exported successfully."
      );
    } catch (error) {
      console.error(
        `${reportType} Export Error:`,
        error
      );

      const errorData =
        error?.response?.data;

      let errorMessage =
        error?.message ||
        "Unable to export Excel file.";

      if (
        errorData instanceof
        ArrayBuffer
      ) {
        try {
          const text =
            new TextDecoder().decode(
              new Uint8Array(
                errorData
              )
            );

          const parsed =
            JSON.parse(text);

          errorMessage =
            parsed?.failureReason ||
            parsed?.FailureReason ||
            parsed?.message ||
            parsed?.Message ||
            errorMessage;
        } catch {
          // keep current error message
        }
      } else if (
        errorData &&
        typeof errorData ===
        "object"
      ) {
        errorMessage =
          errorData?.failureReason ||
          errorData?.FailureReason ||
          errorData?.message ||
          errorData?.Message ||
          errorMessage;
      } else if (
        typeof errorData ===
        "string" &&
        errorData.trim()
      ) {
        errorMessage =
          errorData;
      }

      showNotification(
        "error",
        errorMessage
      );
    } finally {
      setExportingReport(
        ""
      );
    }
  };


  const exportTop10Schools = () => {
    exportDashboardReport(
      "GetTop10SchoolsDashboard",
      "Top10SchoolsDashboard"
    );
  };

  const exportExamPerformanceTrend = () => {
    exportDashboardReport(
      "GetExamPerformanceTrendDashboard",
      "ExamPerformanceTrendDashboard"
    );
  };

  const exportFeesCollection = () => {
    exportDashboardReport(
      "GetFeesCollectionDashboard",
      "FeesCollectionDashboard"
    );
  };

  useEffect(() => {
    if (!fromDate || !toDate) {
      return;
    }

    fetchDashboardTotal();

    fetchTop10Schools();

    fetchExamPerformanceTrend();

    if (isTeacher) {
      fetchTeacherStudentCount();

      fetchTeacherBookPurchase();
    } else {
      fetchFeesCollection();
    }

  }, [
    fromDate,
    toDate,
    isTeacher,
    currentTeacherId,
  ]);


  useEffect(() => {
    if (isTeacher) {
      fetchTeacherTodayStudentCount();
    }
  }, [
    isTeacher,
    currentTeacherId,
  ]);


  const formatRangeDate = (value) => {
    if (!value) {
      return "";
    }

    return new Date(
      `${value}T00:00:00`
    ).toLocaleDateString(
      "en-IN",
      {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }
    );
  };

  const selectedRange = {
    label:
      fromDate && toDate
        ? `${formatRangeDate(
          fromDate
        )} – ${formatRangeDate(
          toDate
        )}`
        : "Select Date Range",
  };

  const chartData =
    examPerformanceData;

  const paidFee =
    feesCollectionData.find(
      (item) =>
        String(
          item.status || ""
        ).toLowerCase() ===
        "paid"
    );

  const feeCollectionPercentage =
    Number(
      paidFee?.percentage || 0
    );

  const formatFeeAmount = (amount) => {
    return Number(
      amount || 0
    ).toLocaleString(
      "en-IN",
      {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0,
      }
    );
  };


  const statCards = [
    {
      icon: "school",
      label: "Total Schools",
      val: dashboardTotalLoading
        ? "..."
        : dashboardTotal.totalSchool.toLocaleString("en-IN"),
      bg: "#EFF6FF",
      ic: "#2563EB",
      page: "schools",
    },

    {
      icon: "student",
      label: isTeacher
        ? "My Students"
        : "Total Students",
      val: isTeacher
        ? teacherStudentCountLoading
          ? "..."
          : teacherStudentCount.toLocaleString("en-IN")
        : dashboardTotalLoading
          ? "..."
          : dashboardTotal.totalStudent.toLocaleString("en-IN"),
      bg: "#ECFDF5",
      ic: "#10B981",
      page: "students",
    },

    {
      icon: "exam",
      label: "Active Exams",
      val: dashboardTotalLoading
        ? "..."
        : dashboardTotal.totalExam.toLocaleString("en-IN"),
      bg: "#FFF7ED",
      ic: "#F97316",
      page: "exams",
    },

    ...(!isTeacher
      ? [
        {
          icon: "fees",
          label: "Total Fees",
          val: dashboardTotalLoading
            ? "..."
            : formatFeeAmount(
              dashboardTotal.totalAmount
            ),
          bg: "#FEF2F2",
          ic: "#EF4444",
          page: "fees",
        },

        {
          icon: "fees",
          label: "Pending Fees",
          val: dashboardTotalLoading
            ? "..."
            : formatFeeAmount(
              dashboardTotal.totalPendingPayment
            ),
          bg: "#FFF7ED",
          ic: "#F59E0B",
          page: "fees",
        },
      ]
      : []),

    {
      icon: "student",
      label: "Today's Students",
      val: isTeacher
        ? teacherTodayStudentLoading
          ? "..."
          : teacherTodayStudentCount.toLocaleString("en-IN")
        : dashboardTotalLoading
          ? "..."
          : dashboardTotal.todaysStudent.toLocaleString("en-IN"),
      bg: "#F5F3FF",
      ic: "#7C3AED",
      page: "students",
    },
  ];

  const topSchools =
    useMemo(() => {
      return [
        ...topSchoolsData,
      ]
        .sort(
          (a, b) =>
            Number(
              b.students || 0
            ) -
            Number(
              a.students || 0
            )
        )
        .slice(0, 10);
    }, [
      topSchoolsData,
    ]);

  const maxStudents = Math.max(
    ...topSchools.map((school) =>
      Number(school.students || 0)
    ),
    1
  );

  const getTopSchoolsAxisStep = (maxValue) => {
    if (maxValue <= 50) {
      return 10;
    }

    const roughStep =
      maxValue / 5;

    const magnitude =
      Math.pow(
        10,
        Math.floor(
          Math.log10(roughStep)
        )
      );

    const normalized =
      roughStep / magnitude;

    let niceStep;

    if (normalized <= 1) {
      niceStep = 1;
    } else if (normalized <= 2) {
      niceStep = 2;
    } else if (normalized <= 5) {
      niceStep = 5;
    } else {
      niceStep = 10;
    }

    return niceStep * magnitude;
  };

  const topSchoolsAxisStep =
    getTopSchoolsAxisStep(
      maxStudents
    );

  const topSchoolsMaxChartValue =
    Math.max(
      50,
      topSchoolsAxisStep * 5
    );

  const topSchoolsYAxisTicks = [
    0,
    topSchoolsAxisStep,
    topSchoolsAxisStep * 2,
    topSchoolsAxisStep * 3,
    topSchoolsAxisStep * 4,
    topSchoolsAxisStep * 5,
  ];
  const navigateTo = (page) => {
    if (typeof onNav === "function") {
      onNav(page);
    }
  };

  const maxExamCount = Math.max(
    ...chartData.map((item) =>
      Number(item.count || 0)
    ),
    0
  );

  const getExamAxisStep = (maxValue) => {
    if (maxValue <= 200) {
      return 50;
    }

    if (maxValue <= 400) {
      return 100;
    }

    if (maxValue <= 1000) {
      return 250;
    }

    if (maxValue <= 2000) {
      return 500;
    }

    return Math.ceil(
      maxValue / 4 / 1000
    ) * 1000;
  };

  const examAxisStep =
    getExamAxisStep(maxExamCount);

  const maxChartValue =
    Math.max(
      200,
      Math.ceil(
        maxExamCount /
        examAxisStep
      ) *
      examAxisStep
    );

  const examYAxisTicks = [];

  for (
    let value = 0;
    value <= maxChartValue;
    value += examAxisStep
  ) {
    examYAxisTicks.push(value);
  }

  const getPointX = (index) => {
    if (topSchools.length <= 1) {
      return 500;
    }

    return (
      (index / (topSchools.length - 1)) *
      1000
    );
  };

  const getPointY = (students) => {
    return (
      230 -
      (
        students /
        topSchoolsMaxChartValue
      ) *
      230
    );
  };

  const linePoints = topSchools
    .map((school, index) => {
      const students = Number(
        school.students || 0
      );

      const x = getPointX(index);
      const y = getPointY(students);

      return `${x},${y}`;
    })
    .join(" ");

  const areaPoints =
    topSchools.length > 0
      ? `${linePoints} 1000,230 0,230`
      : "";

  return (
    <>
      {notification && (
        <div
          style={{
            position: "fixed",
            top: "20px",
            right: "20px",
            zIndex: 99999,
            minWidth: "280px",
            maxWidth: "420px",
            padding: "12px 16px",
            borderRadius: "8px",
            backgroundColor:
              notification.type === "success"
                ? "#d1e7dd"
                : "#f8d7da",
            color:
              notification.type === "success"
                ? "#0f5132"
                : "#842029",
            border:
              notification.type === "success"
                ? "1px solid #badbcc"
                : "1px solid #f5c2c7",
            fontSize: "14px",
            fontWeight: 600,
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          }}
        >
          {notification.type === "success" ? "✓ " : "✕ "}
          {notification.message}
        </div>
      )}

      <div
        className="stat-grid"
        style={{
          display: "grid",
          gap: 14,
          width: "100%",
        }}
      >
        {statCards.map((stat) => (
          <div
            className="stat-card"
            key={stat.label}
            onClick={() =>
              navigateTo(stat.page)
            }
            style={{
              cursor: "pointer",
              transition:
                "all .2s ease",
            }}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (
                e.key === "Enter" ||
                e.key === " "
              ) {
                navigateTo(stat.page);
              }
            }}
          >
            <div className="stat-top">
              <div
                className="stat-icon"
                style={{
                  background: stat.bg,
                }}
              >
                <I
                  n={stat.icon}
                  s={20}
                  c={stat.ic}
                />
              </div>
            </div>

            <div className="stat-val">
              {stat.val}
            </div>

            <div className="stat-lbl">
              {stat.label}
            </div>
          </div>
        ))}
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginBottom: 16,
          gap: 10,
          flexWrap: "wrap",
        }}
      >

        <span
          style={{
            fontSize: 12,
            color: "var(--t2)",
            fontWeight: 600,
          }}
        >
          From
        </span>

        <input
          type="date"
          value={fromDate}
          max={
            toDate &&
              toDate < getTodayDate()
              ? toDate
              : getTodayDate()
          }
          onChange={(e) => {
            const value =
              e.target.value;

            if (
              value &&
              value > getTodayDate()
            ) {
              showNotification(
                "error",
                "Future date is not allowed."
              );
              return;
            }

            setFromDate(value);
          }}
          style={{
            border:
              "1px solid var(--bd)",
            background: "#fff",
            color: "var(--t1)",
            borderRadius:
              "var(--r3)",
            height: 40,
            padding:
              "0 12px",
            boxSizing:
              "border-box",
            fontSize: 12,
            fontWeight: 600,
            cursor: "pointer",
            outline: "none",
            fontFamily: "inherit",
          }}
        />

        {/* TO */}
        <span
          style={{
            fontSize: 12,
            color: "var(--t2)",
            fontWeight: 600,
          }}
        >
          To
        </span>

        <input
          type="date"
          value={toDate}
          min={fromDate || undefined}
          max={getTodayDate()}
          onChange={(e) => {
            const value =
              e.target.value;

            if (
              value &&
              value > getTodayDate()
            ) {
              showNotification(
                "error",
                "Future date is not allowed."
              );
              return;
            }

            setToDate(value);
          }}
          style={{
            border:
              "1px solid var(--bd)",
            background: "#fff",
            color: "var(--t1)",
            borderRadius:
              "var(--r3)",
            height: 40,
            padding:
              "0 12px",
            boxSizing:
              "border-box",
            fontSize: 12,
            fontWeight: 600,
            cursor: "pointer",
            outline: "none",
            fontFamily: "inherit",
          }}
        />
      </div>
      <div className="chart-grid">

        <div className="card cp">
          <div
            style={{
              display: "flex",
              justifyContent:
                "space-between",
              alignItems:
                "flex-start",
              gap: 10,
              marginBottom: 18,
            }}
          >
            <div>
              <div
                style={{
                  fontWeight: 700,
                  fontSize: 14,
                }}
              >
                Exam Performance Trend
              </div>

              <div
                style={{
                  fontSize: 12,
                  color: "var(--t3)",
                  marginTop: 2,
                }}
              >
                Student participation count per
                exam —{" "}
                {selectedRange.label}
              </div>
            </div>

            <button
              type="button"
              className="btn btn-g"
              disabled={Boolean(
                exportingReport
              )}
              onClick={
                exportExamPerformanceTrend
              }
            >
              <I
                n="download"
                s={12}
              />

              {exportingReport ===
                "GetExamPerformanceTrendDashboard"
                ? "Exporting..."
                : "Export"}
            </button>
          </div>

          {examPerformanceLoading ? (
            <div
              style={{
                height: 205,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "var(--t3)",
                fontSize: 13,
              }}
            >
              Loading exam performance...
            </div>
          ) : chartData.length === 0 ? (
            <div
              style={{
                height: 205,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "var(--t3)",
                fontSize: 13,
              }}
            >
              No exam performance data available
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                gap: 0,
              }}
            >
              {/* Y AXIS */}

              <div
                style={{
                  display: "flex",
                  flexDirection:
                    "column-reverse",
                  justifyContent:
                    "space-between",
                  paddingBottom: 28,
                  paddingRight: 8,
                  width: 38,
                }}
              >
                {examYAxisTicks.map(
                  (value) => (
                    <span
                      key={value}
                      style={{
                        fontSize: 9,
                        color:
                          "var(--t3)",
                        fontWeight: 600,
                        textAlign:
                          "right",
                      }}
                    >
                      {value}
                    </span>
                  )
                )}
              </div>

              {/* GRAPH */}

              <div
                style={{
                  flex: 1,
                  minWidth: 0,
                }}
              >
                <div
                  style={{
                    position:
                      "relative",
                    height: 160,
                    borderLeft:
                      "1.5px solid var(--bd)",
                    borderBottom:
                      "1.5px solid var(--bd)",
                  }}
                >
                  {/* GRID */}

                  {examYAxisTicks
                    .slice(1)
                    .map((value) => (
                      <div
                        key={value}
                        style={{
                          position:
                            "absolute",
                          left: 0,
                          right: 0,
                          bottom: `${(value /
                            maxChartValue) *
                            100
                            }%`,
                          borderTop:
                            "1px dashed #E9EEF5",
                        }}
                      />
                    ))}

                  {/* BARS */}

                  <div
                    style={{
                      display: "flex",
                      alignItems:
                        "flex-end",
                      gap: 8,
                      height: "100%",
                      padding:
                        "0 10px",
                    }}
                  >
                    {chartData.map(
                      (
                        data,
                        index
                      ) => (
                        <div
                          key={`${dateRange}-${data.label}-${index}`}
                          style={{
                            flex: 1,
                            display:
                              "flex",
                            flexDirection:
                              "column",
                            alignItems:
                              "center",
                            height:
                              "100%",
                            justifyContent:
                              "flex-end",
                            minWidth: 0,
                          }}
                        >
                          <div
                            style={{
                              fontSize: 9,
                              fontWeight: 700,
                              color:
                                data.color,
                              marginBottom: 3,
                            }}
                          >
                            {data.count}
                          </div>

                          <div
                            title={`${data.label}: ${data.count} students`}
                            style={{
                              width:
                                "100%",
                              height: `${Math.max(
                                (data.count /
                                  maxChartValue) *
                                100,
                                3
                              )}%`,
                              background:
                                data.color,
                              borderRadius:
                                "4px 4px 0 0",
                              opacity:
                                0.88,
                              minHeight: 4,
                              transition:
                                "height .4s ease",
                              cursor:
                                "pointer",
                            }}
                          />
                        </div>
                      )
                    )}
                  </div>
                </div>

                {/* X AXIS */}

                <div
                  style={{
                    display: "flex",
                    gap: 8,
                    padding:
                      "6px 10px 0",
                  }}
                >
                  {chartData.map(
                    (
                      data,
                      index
                    ) => (
                      <div
                        key={`${dateRange}-exam-label-${index}`}
                        style={{
                          flex: 1,
                          textAlign:
                            "center",
                          fontSize: 8.5,
                          color:
                            "var(--t3)",
                          fontWeight: 500,
                          lineHeight: 1.3,
                          overflow:
                            "hidden",
                          textOverflow:
                            "ellipsis",
                          whiteSpace:
                            "nowrap",
                        }}
                        title={
                          data.label
                        }
                      >
                        {data.label}
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        {isTeacher ? (
          <div className="card cp">
            <div
              style={{
                fontWeight: 700,
                fontSize: 14,
                marginBottom: 2,
              }}
            >
              Book Purchase
            </div>

            <div
              style={{
                fontSize: 12,
                color: "var(--t3)",
                marginBottom: 18,
              }}
            >
              Book purchase trend —{" "}
              {selectedRange.label}
            </div>

            {bookPurchaseLoading ? (
              <div
                style={{
                  height: 205,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "var(--t3)",
                  fontSize: 13,
                }}
              >
                Loading book purchase...
              </div>
            ) : bookPurchaseData.length === 0 ? (
              <div
                style={{
                  height: 205,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "var(--t3)",
                  fontSize: 13,
                }}
              >
                No book purchase data available
              </div>
            ) : (
              (() => {
                const maxBookCount = Math.max(
                  ...bookPurchaseData.map(
                    (item) =>
                      Number(item.count || 0)
                  ),
                  0
                );

                const bookAxisStep =
                  maxBookCount <= 50
                    ? 10
                    : maxBookCount <= 100
                      ? 20
                      : maxBookCount <= 250
                        ? 50
                        : 100;

                const bookMaxChartValue =
                  Math.max(
                    50,
                    Math.ceil(
                      maxBookCount /
                      bookAxisStep
                    ) * bookAxisStep
                  );

                const bookYAxisTicks = [];

                for (
                  let value = 0;
                  value <=
                  bookMaxChartValue;
                  value += bookAxisStep
                ) {
                  bookYAxisTicks.push(
                    value
                  );
                }

                return (
                  <div
                    style={{
                      display: "flex",
                      gap: 0,
                    }}
                  >
                    {/* Y AXIS */}

                    <div
                      style={{
                        display: "flex",
                        flexDirection:
                          "column-reverse",
                        justifyContent:
                          "space-between",
                        paddingBottom: 28,
                        paddingRight: 8,
                        width: 38,
                      }}
                    >
                      {bookYAxisTicks.map(
                        (value) => (
                          <span
                            key={value}
                            style={{
                              fontSize: 9,
                              color:
                                "var(--t3)",
                              fontWeight: 600,
                              textAlign:
                                "right",
                            }}
                          >
                            {value}
                          </span>
                        )
                      )}
                    </div>

                    {/* GRAPH */}

                    <div
                      style={{
                        flex: 1,
                        minWidth: 0,
                      }}
                    >
                      <div
                        style={{
                          position:
                            "relative",
                          height: 160,
                          borderLeft:
                            "1.5px solid var(--bd)",
                          borderBottom:
                            "1.5px solid var(--bd)",
                        }}
                      >
                        {/* GRID */}

                        {bookYAxisTicks
                          .slice(1)
                          .map((value) => (
                            <div
                              key={value}
                              style={{
                                position:
                                  "absolute",
                                left: 0,
                                right: 0,
                                bottom: `${(
                                  value /
                                  bookMaxChartValue
                                ) * 100}%`,
                                borderTop:
                                  "1px dashed #E9EEF5",
                              }}
                            />
                          ))}

                        {/* BARS */}

                        <div
                          style={{
                            display: "flex",
                            alignItems:
                              "flex-end",
                            gap: 8,
                            height: "100%",
                            padding:
                              "0 10px",
                          }}
                        >
                          {bookPurchaseData.map(
                            (
                              item,
                              index
                            ) => (
                              <div
                                key={`${item.label}-${index}`}
                                style={{
                                  flex: 1,
                                  display:
                                    "flex",
                                  flexDirection:
                                    "column",
                                  alignItems:
                                    "center",
                                  height:
                                    "100%",
                                  justifyContent:
                                    "flex-end",
                                  minWidth: 0,
                                }}
                              >
                                <div
                                  style={{
                                    fontSize: 9,
                                    fontWeight: 700,
                                    color:
                                      item.color,
                                    marginBottom: 3,
                                  }}
                                >
                                  {item.count}
                                </div>

                                <div
                                  title={`${item.label}: ${item.count} quantity`}
                                  style={{
                                    width:
                                      "100%",
                                    height: `${Math.max(
                                      (
                                        Number(
                                          item.count ||
                                          0
                                        ) /
                                        bookMaxChartValue
                                      ) * 100,
                                      3
                                    )}%`,
                                    background:
                                      item.color,
                                    borderRadius:
                                      "4px 4px 0 0",
                                    opacity: 0.88,
                                    minHeight: 4,
                                    transition:
                                      "height .4s ease",
                                    cursor:
                                      "pointer",
                                  }}
                                />
                              </div>
                            )
                          )}
                        </div>
                      </div>

                      {/* X AXIS */}

                      <div
                        style={{
                          display: "flex",
                          gap: 8,
                          padding:
                            "6px 10px 0",
                        }}
                      >
                        {bookPurchaseData.map(
                          (
                            item,
                            index
                          ) => (
                            <div
                              key={`book-label-${index}`}
                              style={{
                                flex: 1,
                                textAlign:
                                  "center",
                                fontSize: 8.5,
                                color:
                                  "var(--t3)",
                                fontWeight: 500,
                                overflow:
                                  "hidden",
                                textOverflow:
                                  "ellipsis",
                                whiteSpace:
                                  "nowrap",
                              }}
                              title={
                                item.label
                              }
                            >
                              {item.label}
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                );
              })()
            )}
          </div>
        ) : (
          <div
            className="card cp"
            onClick={() =>
              navigateTo("fees")
            }
            style={{
              cursor: "pointer",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent:
                  "space-between",
                alignItems:
                  "flex-start",
                gap: 10,
                marginBottom: 18,
              }}
            >
              <div>
                <div
                  style={{
                    fontWeight: 700,
                    fontSize: 14,
                    marginBottom: 2,
                  }}
                >
                  Fees Collection
                </div>

                <div
                  style={{
                    fontSize: 12,
                    color: "var(--t3)",
                  }}
                >
                  Overall status —{" "}
                  {selectedRange.label}
                </div>
              </div>

              <button
                type="button"
                className="btn btn-g"
                disabled={Boolean(
                  exportingReport
                )}
                onClick={(e) => {
                  e.stopPropagation();
                  exportFeesCollection();
                }}
              >
                <I
                  n="download"
                  s={12}
                />

                {exportingReport ===
                  "GetFeesCollectionDashboard"
                  ? "Exporting..."
                  : "Export"}
              </button>
            </div>

            {feesCollectionLoading ? (
              <div
                style={{
                  height: 150,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "var(--t3)",
                  fontSize: 13,
                }}
              >
                Loading fees collection...
              </div>
            ) : feesCollectionData.length === 0 ? (
              <div
                style={{
                  height: 150,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "var(--t3)",
                  fontSize: 13,
                }}
              >
                No fees collection data available
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 22,
                }}
              >
                {/* DONUT */}

                <div
                  className="donut"
                  style={{
                    background: `conic-gradient(
                      #10B981 0% ${feeCollectionPercentage}%,
                      #E5E7EB ${feeCollectionPercentage}% 100%
                    )`,
                  }}
                >
                  <div className="dhole">
                    <div className="dv_">
                      {feeCollectionPercentage}%
                    </div>

                    <div className="ds_">
                      Collected
                    </div>
                  </div>
                </div>

                {/* FEES DETAILS */}

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 10,
                    flex: 1,
                  }}
                >
                  {feesCollectionData.map(
                    (item, index) => {
                      const status =
                        String(
                          item.status || ""
                        ).toLowerCase();

                      const color =
                        status === "paid"
                          ? "#10B981"
                          : status === "pending"
                            ? "#F59E0B"
                            : status === "processing"
                              ? "#2563EB"
                              : status === "overdue"
                                ? "#F97316"
                                : "#EF4444";

                      return (
                        <div
                          key={`${item.status}-${index}`}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                          }}
                        >
                          <div
                            style={{
                              width: 9,
                              height: 9,
                              borderRadius: 2,
                              background: color,
                              flexShrink: 0,
                            }}
                          />

                          <span
                            style={{
                              fontSize: 12.5,
                              color: "var(--t2)",
                              flex: 1,
                            }}
                          >
                            {item.status}
                          </span>

                          <span
                            style={{
                              fontSize: 12.5,
                              fontWeight: 700,
                              color: "var(--t1)",
                            }}
                          >
                            {formatFeeAmount(
                              item.amount
                            )}
                          </span>
                        </div>
                      );
                    }
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      <div
        className="card cp"
        style={{
          marginTop: 20,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent:
              "space-between",
            alignItems:
              "center",
            marginBottom: 20,
          }}
        >
          <div>
            <div
              style={{
                fontWeight: 700,
                fontSize: 14,
              }}
            >
              Top 10 Schools by Students
            </div>

            <div
              style={{
                fontSize: 12,
                color: "var(--t3)",
                marginTop: 3,
              }}
            >
              Student enrollment trend —{" "}
              {selectedRange.label}
            </div>
          </div>

          <button
            type="button"
            className="btn btn-g"
            disabled={Boolean(
              exportingReport
            )}
            onClick={
              exportTop10Schools
            }
          >
            <I
              n="download"
              s={12}
            />

            {exportingReport ===
              "GetTop10SchoolsDashboard"
              ? "Exporting..."
              : "Export"}
          </button>
        </div>

        {topSchoolsLoading ? (
          <div
            style={{
              padding:
                "35px 10px",
              textAlign:
                "center",
              color:
                "var(--t3)",
              fontSize: 13,
            }}
          >
            Loading top 10 schools...
          </div>
        ) : topSchools.length === 0 ? (
          <div
            style={{
              padding:
                "35px 10px",
              textAlign:
                "center",
              color:
                "var(--t3)",
              fontSize: 13,
            }}
          >
            No school data
            available
          </div>
        ) : (
          <div
            style={{
              width: "100%",
              overflowX:
                "auto",
              paddingBottom: 5,
            }}
          >
            <div
              style={{
                minWidth: 750,
                position:
                  "relative",
              }}
            >
              <div
                style={{
                  display:
                    "flex",
                }}
              >
                <div
                  style={{
                    width: 55,
                    height: 280,
                    display:
                      "flex",
                    flexDirection:
                      "column",
                    justifyContent:
                      "space-between",
                    paddingBottom:
                      34,
                    paddingTop: 5,
                    flexShrink: 0,
                  }}
                >
                  {[
                    ...topSchoolsYAxisTicks,
                  ]
                    .reverse()
                    .map((value) => (
                      <span
                        key={value}
                        style={{
                          fontSize: 10,
                          color: "var(--t3)",
                          fontWeight: 600,
                          textAlign: "right",
                          paddingRight: 8,
                        }}
                      >
                        {value}
                      </span>
                    ))}
                </div>
                <div
                  style={{
                    flex: 1,
                    height: 280,
                    position:
                      "relative",
                    borderLeft:
                      "1px solid var(--bd)",
                    borderBottom:
                      "1px solid var(--bd)",
                  }}
                >
                  {topSchoolsYAxisTicks.map(
                    (value) => (
                      <div
                        key={value}
                        style={{
                          position:
                            "absolute",
                          left: 0,
                          right: 0,
                          bottom: `${(
                            value /
                            topSchoolsMaxChartValue
                          ) * 100}%`,
                          borderTop:
                            "1px dashed #E8EDF4",
                        }}
                      />
                    )
                  )}

                  <div
                    style={{
                      position:
                        "absolute",
                      inset: 0,
                      padding:
                        "10px 15px 34px",
                    }}
                  >
                    <svg
                      width="100%"
                      height="100%"
                      viewBox="0 0 1000 230"
                      preserveAspectRatio="none"
                      style={{
                        overflow:
                          "visible",
                      }}
                    >
                      <defs>
                        <linearGradient
                          id={`schoolGradient-${dateRange}`}
                          x1="0"
                          y1="0"
                          x2="0"
                          y2="1"
                        >
                          <stop
                            offset="0%"
                            stopColor="#2563EB"
                            stopOpacity="0.20"
                          />

                          <stop
                            offset="100%"
                            stopColor="#2563EB"
                            stopOpacity="0"
                          />
                        </linearGradient>
                      </defs>
                      <polygon
                        points={
                          areaPoints
                        }
                        fill={`url(#schoolGradient-${dateRange})`}
                      />
                      <polyline
                        points={
                          linePoints
                        }
                        fill="none"
                        stroke="#2563EB"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        vectorEffect="non-scaling-stroke"
                      />
                      {topSchools.map(
                        (
                          school,
                          index
                        ) => {
                          const students =
                            Number(
                              school.students ||
                              0
                            );

                          const x =
                            getPointX(
                              index
                            );

                          const y =
                            getPointY(
                              students
                            );

                          return (
                            <g
                              key={`${dateRange}-${school.name}-${index}`}
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              {/* HOVER TOOLTIP */}
                              <title>
                                {`${school.name} - ${students} Students`}
                              </title>
                              <text
                                x={x}
                                y={y - 16}
                                textAnchor="middle"
                                fontSize="11"
                                fontWeight="700"
                                fill="#2563EB"
                                style={{
                                  pointerEvents: "none",
                                }}
                              >
                                {students}
                              </text>
                              <circle
                                cx={x}
                                cy={y}
                                r="9"
                                fill="#FFFFFF"
                                stroke="#2563EB"
                                strokeWidth="3"
                                vectorEffect="non-scaling-stroke"
                              />
                              <circle
                                cx={x}
                                cy={y}
                                r="3"
                                fill="#2563EB"
                              />
                            </g>
                          );
                        }
                      )}
                    </svg>
                    <div
                      style={{
                        position:
                          "absolute",
                        left: 15,
                        right: 15,
                        bottom: 0,
                        height: 30,
                        display:
                          "flex",
                      }}
                    >
                      {topSchools.map(
                        (
                          school,
                          index
                        ) => (
                          <div
                            key={`${dateRange}-school-${index}`}
                            onClick={() =>
                              navigateTo(
                                "schools"
                              )
                            }
                            style={{
                              flex: 1,
                              minWidth: 0,
                              textAlign:
                                "center",
                              cursor:
                                "pointer",
                              padding:
                                "0 3px",
                            }}
                            title={
                              school.name
                            }
                          >
                            <div
                              style={{
                                fontSize: 9,
                                color:
                                  "var(--t2)",
                                fontWeight: 600,
                                overflow:
                                  "hidden",
                                textOverflow:
                                  "ellipsis",
                                whiteSpace:
                                  "nowrap",
                              }}
                            >
                              {
                                school.name
                              }
                            </div>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {topSchools.length > 0 && (
          <div
            style={{
              display:
                "flex",
              justifyContent:
                "space-between",
              alignItems:
                "center",
              marginTop: 16,
              paddingTop: 12,
              borderTop:
                "1px solid var(--bd)",
              flexWrap:
                "wrap",
              gap: 10,
            }}
          >
            <div
              style={{
                display:
                  "flex",
                alignItems:
                  "center",
                gap: 7,
              }}
            >
              <span
                style={{
                  width: 9,
                  height: 9,
                  borderRadius:
                    "50%",
                  background:
                    "#2563EB",
                }}
              />

              <span
                style={{
                  fontSize: 11.5,
                  color:
                    "var(--t2)",
                }}
              >
                Student Enrollment
              </span>
            </div>

            <div
              style={{
                fontSize: 11.5,
                color:
                  "var(--t3)",
              }}
            >
              Highest:{" "}
              <strong
                style={{
                  color:
                    "var(--t1)",
                }}
              >
                {maxStudents.toLocaleString()}
              </strong>{" "}
              students
            </div>
          </div>
        )}
      </div>
    </>
  );
}